import { Injectable } from '@angular/core';
import { ProfileWeight } from 'src/app/interfaces/profile-weight';
import { APIProviderService } from '../api/api.provider.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileWeightsProviderService extends APIProviderService<ProfileWeight> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/FormWeights`;
  }
}
